import { AppointmentTypeEnum } from 'graphql/generated/remote-schema-hasura';
import { ServiceOfferingType } from '../components/select-a-provider/ProviderCardProps';

export type BaseType = AppointmentTypeEnum.Chat | AppointmentTypeEnum.Video;

export type AppointmentDurationInfo = {
  live: number;
  docNotes: number;
  total: number;
};

const DEFAULT_DURATION = '15';

const APPOINTMENT_DURATION_INFO: Record<string, AppointmentDurationInfo> = {
  15: { live: 12, docNotes: 3, total: 15 },
  30: { live: 25, docNotes: 5, total: 30 },
  60: { live: 52, docNotes: 8, total: 60 },
};

export const toBaseTypeServiceType = (serviceType: string): BaseType | null => {
  const head = String(serviceType).split('_')[0];
  if (head === 'CHAT') return AppointmentTypeEnum.Chat;
  if (head === 'VIDEO') return AppointmentTypeEnum.Video;
  return null;
};

export const parseDuration = (
  serviceType: string,
): AppointmentDurationInfo | null => {
  const total = String(serviceType).split('_')[1] || DEFAULT_DURATION;

  return APPOINTMENT_DURATION_INFO[total];
};

export type GroupsResultServiceType = Partial<
  Record<BaseType, { minPrice: number; count: number }>
>;

export function buildGroupsServiceType(
  items: ServiceOfferingType[],
): GroupsResultServiceType {
  const acc: GroupsResultServiceType = {};

  for (const item of items) {
    if (!item?.active) continue;

    const baseType = toBaseTypeServiceType(item.serviceType);
    if (!baseType) continue;

    const total = Number(item.price) || 0;

    const bucket = acc[baseType];
    if (!bucket) {
      acc[baseType] = { minPrice: total, count: 1 };
    } else {
      bucket.minPrice = Math.min(bucket.minPrice, total);
      bucket.count += 1;
    }
  }

  return acc;
}
